<template>
  <span :class="markStyle" >{{mark()}}</span>
</template>

<script>
import { toRef, computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    checked: {
      default: true
    }
  },
  setup (props) {
    const checked = toRef(props, 'checked')

    const mark = () => {
      console.log(checked.value)
      return checked.value ? '✔' : '✖'
    }

    const markStyle = computed(() => {
      return { active: checked.value, notActive: !checked.value }
    })

    return {
      mark,
      markStyle
    }
  }
})

</script>

<style scoped>
  span.notActive {
    color: red;
  }
  span.active {
    color: green;
  }
</style>
